class ToastService {
  constructor() {
    this.toastStackRef = null;
  }

  setToastStackRef(ref) {
    this.toastStackRef = ref;
  }

  showLoadingToast(message, color = 'bg-info') {
    if (!this.toastStackRef) {
      console.error('ToastStack ref not set');
      return null;
    }
    return this.toastStackRef.addToast(message, color, true, false);
  }

  hideLoadingToast(toastId, finalMessage = null, finalColor = 'bg-success', autoHide = true) {
    if (!this.toastStackRef) {
      console.error('ToastStack ref not set');
      return;
    }

    if (finalMessage) {
      this.toastStackRef.updateToast(toastId, {
        message: finalMessage,
        loading: false,
        color: finalColor
      });
      if (autoHide) {
        setTimeout(() => {
          this.toastStackRef.removeToast(toastId);
        }, 3000);
      }
    } else {
      this.toastStackRef.removeToast(toastId);
    }
  }

  showToast(message, color = 'bg-info', autoHide = true, duration = 3000) {
    if (!this.toastStackRef) {
      console.error('ToastStack ref not set');
      return null;
    }
    return this.toastStackRef.addToast(message, color, false, autoHide, duration);
  }
}

// Singleton instance
const toastService = new ToastService();
export default toastService;

